<template>
  <div>
    <!--    <message v-show="error" class="error-message" :title="'Error'" :container="'.styles-box'" :type="'danger'" :direction="'down'" :message=error :duration="0"></message>-->

    <h2 class="text-h6">Billing account</h2>
    <h3 class="h4 subtitle mb-4">Manage billing details.</h3>

    <template v-if="!edit">
      <!--      <div class="tile buttons">-->
      <!--        <a @click="editForm" class="button is-primary">-->
      <!--          <span class="icon"><i class="fa fa-pencil"></i></span><span>Edit settings</span>-->
      <!--        </a>-->
      <!--      </div>-->

      <c-button color="primary" class="mb-4" @click="editForm">Edit settings</c-button>

      <template v-if="organisation">
        <table class="table">
          <tr>
            <td>Bill to</td>
            <td>
              <span v-if="organisation.config.billing.billTo">{{ organisation.config.billing.billTo }}</span>
              <span v-else class="not-set">Not set</span>
            </td>
            <td>
              <p v-html="fieldDescriptions.billTo" />
            </td>
          </tr>
          <tr>
            <td>Email</td>
            <td>
              <span v-if="organisation.config.billing.email">{{ organisation.config.billing.email }}</span>
              <span v-else class="not-set">Not set</span>
            </td>
            <td>
              <p v-html="fieldDescriptions.email" />
            </td>
          </tr>
          <tr>
            <td>Phone number</td>
            <td>
              <span v-if="organisation.config.billing.phoneNumber">{{ organisation.config.billing.phoneNumber }}</span>
              <span v-else class="not-set">Not set</span>
            </td>
            <td>
              <p v-html="fieldDescriptions.phoneNumber" />
            </td>
          </tr>
          <tr>
            <td>Country</td>
            <td>
              <span v-if="organisation.config.billing.country">
                {{ countries[organisation.config.billing.country].name }}
              </span>
              <span v-else class="not-set">Not set</span>
            </td>
            <td>
              <p v-html="fieldDescriptions.country" />
            </td>
          </tr>
        </table>
      </template>
      <template v-else>
        <p>No billing information has been entered.</p>
      </template>
    </template>

    <template v-if="edit">
      <table class="table">
        <tr>
          <td>Bill to</td>
          <td>
            <c-input
              v-model="data.body.billTo"
              class="input"
              type="text"
              :class="{ 'is-danger': requiredFields['data.body.billTo'] }"
              placeholder="Michael Scott"
            />
            <!--            <span class="help is-danger">{{validation.firstError('data.body.billTo')}}</span>-->
          </td>
          <td>
            <p v-html="fieldDescriptions.billTo" />
          </td>
        </tr>
        <tr>
          <td>Email</td>
          <td>
            <c-input
              v-model="data.body.email"
              class="input"
              type="text"
              :class="{ 'is-danger': requiredFields['data.body.email'] }"
              placeholder="michael@dundermifflin.com"
            />
            <!--            <span class="help is-danger">{{validation.firstError('data.body.email')}}</span>-->
          </td>
          <td>
            <p v-html="fieldDescriptions.email" />
          </td>
        </tr>
        <tr>
          <td>Phone number</td>
          <td>
            <c-input
              v-model="data.body.phoneNumber"
              class="input"
              type="text"
              :class="{ 'is-danger': requiredFields['data.body.phoneNumber'] }"
              placeholder="Your phone number"
            />
            <!--            <span class="help is-danger">{{validation.firstError('data.body.phoneNumber')}}</span>-->
          </td>
          <td>
            <p v-html="fieldDescriptions.phoneNumber" />
          </td>
        </tr>
        <tr>
          <td>Country</td>
          <td>
            <span class="select">
              <select
                v-model="data.body.country"
                class="category"
                :class="{ 'is-danger': requiredFields['data.body.country'] }"
              >
                <option disabled value="">Please select one</option>
                <option v-for="country in countryList" :value="country.code">
                  {{ country.name }}
                </option>
              </select>
            </span>
            <!--            <span class="help is-danger">{{validation.firstError('data.body.country')}}</span>-->
          </td>
          <td>
            <p v-html="fieldDescriptions.country" />
          </td>
        </tr>
      </table>

      <!--      <div class="block">-->
      <!--        <p class="control">-->
      <!--          <button class="button is-primary" @click="save()" :class="{'is-loading': isSaving}">Update</button>-->
      <!--          <button class="button is-link" @click="cancelEdit()">Cancel</button>-->
      <!--        </p>-->
      <!--      </div>-->

      <c-button-group>
        <c-button color="primary" @click="save">
          <c-spinner v-if="isSaving" color="success" size="sm" />
          <span v-else>Update</span>
        </c-button>
        <c-button color="secondary" :disabled="isSaving" @click="cancelEdit">Cancel</c-button>
      </c-button-group>
    </template>

    <h2 class="text-h6" style="margin-top: 40px; margin-bottom: 5px;">Payment method</h2>

    <template v-if="billingMinimumRequirements()">
      <card :organisation="organisation" />
    </template>

    <template v-else>
      <h2 class="subtitle" style="margin-top: 20px">
        Billing details must be completed before a payment method can be added.
      </h2>
    </template>
  </div>
</template>

<script>
import { countries } from 'countries-list';
// import Message from 'vue-bulma-message'
// import { Tabs, TabPane } from 'vue-bulma-tabs'
import SimpleVueValidation from 'simple-vue-validator';
import _ from 'lodash';
import fieldHighlights from '../../../libs/forms/fieldHighlights';
import { buildEndpoint } from '../../../libs/buildEndPoint';
import Card from './card';

const { Validator } = SimpleVueValidation;

export default {
  components: {
    // Message,
    // Tabs,
    // TabPane,
    Card,
  },

  props: {
    organisation: Object,
  },

  data() {
    return {
      error: null,
      billing: null,
      edit: false,
      countries,
      countryList: [],
      isSaving: false,
      isSending: false,
      yesNoOptions: [
        {
          code: 'y',
          description: 'Yes',
        },
        {
          code: 'n',
          description: 'No',
        },
      ],
      data: {
        body: {
          billTo: null,
          email: null,
          phoneNumber: null,
          country: null,
        },
      },
      requiredFields: {
        'data.body.billTo': false,
        'data.body.email': false,
        'data.body.phoneNumber': false,
        'data.body.country': false,
      },
      fieldDescriptions: {
        billTo: 'The name of whom we will make the invoice out to',
        email: 'The email address we will send invocie notifications to',
        phoneNumber: "The phone number we will call if we can't reach you via email",
        country: 'The country of the credit card used ',
      },
    };
  },

  validators: {
    'data.body.billTo': function (value) {
      return Validator.value(value).required();
    },
    'data.body.email': function (value) {
      return Validator.value(value)
        .email()
        .required();
    },
    'data.body.phoneNumber': function (value) {
      return Validator.value(value).required();
    },
    'data.body.country': function (value) {
      return Validator.value(value).required();
    },
  },

  watch: {
    // 'data.body.billTo' (val) {
    //   fieldHighlights.highlight(this.validation, this.requiredFields)
    // },
    // 'data.body.email' (val) {
    //   fieldHighlights.highlight(this.validation, this.requiredFields)
    // },
    // 'data.body.phoneNumber' (val) {
    //   fieldHighlights.highlight(this.validation, this.requiredFields)
    // },
    // 'data.body.country' (val) {
    //   fieldHighlights.highlight(this.validation, this.requiredFields)
    // }
  },

  created() {
    this.setData();
    this.getCountries();
  },

  methods: {
    getCountries() {
      const countryList = [];
      Object.keys(countries).forEach((key, index) => {
        countryList.push({
          code: key,
          name: countries[key].name,
        });
      });
      this.countryList = countryList;
    },
    billingMinimumRequirements() {
      return (
        _.get(this.organisation, 'config.billing.billTo')
        && _.get(this.organisation, 'config.billing.email')
        && _.get(this.organisation, 'config.billing.phoneNumber')
        && _.get(this.organisation, 'config.billing.country')
      );
    },
    setData() {
      if (_.has(this.organisation, 'config.billing')) {
        this.billing = this.organisation.config.billing;
      }
      this.data.body.billTo = _.get(this.organisation, 'config.billing.billTo', '');
      this.data.body.email = _.get(this.organisation, 'config.billing.email', '');
      this.data.body.phoneNumber = _.get(this.organisation, 'config.billing.phoneNumber', '');
      this.data.body.country = _.get(this.organisation, 'config.billing.country', '');
    },
    editForm() {
      this.edit = true;
    },
    cancelEdit() {
      this.edit = false;
      this.setData();
    },
    save() {
      this.$validate().then((success) => {
        if (success) {
          this.isSaving = true;
          this.error = null;

          const data = {
            id: this.organisation._id,
            billTo: this.data.body.billTo,
            email: this.data.body.email,
            phoneNumber: this.data.body.phoneNumber,
            country: this.data.body.country,
          };

          this.$http
            .post(buildEndpoint('organisation-admin/organisation/billing/update'), data)
            .then((response) => {
              this.isSaving = false;
              if (response.data.success) {
                // Update data in read only view
                this.organisation.config.billing.billTo = data.billTo;
                this.organisation.config.billing.email = data.email;
                this.organisation.config.billing.phoneNumber = data.phoneNumber;
                this.organisation.config.billing.country = data.country;
                this.edit = false;
              } else {
                this.error = 'Error saving billing details';
              }
            })
            .catch((error) => {
              this.isSaving = false;
              this.error = error;
            });
        } else {
          fieldHighlights.highlight(this.validation, this.requiredFields);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped="">
table {
  tr {
    td {
      &:first-child {
        font-weight: bold;
        width: 200px;
      }
      &:last-child {
        font-style: italic;
      }
      .not-set {
        color: silver;
      }
    }
  }
}
.buttons {
  margin-bottom: 20px;
}
.info {
  font-weight: normal;
  font-style: italic;
  margin-bottom: 20px;
}
</style>
